  <div class="modal-header">
    @if (selectedReport()?.type === ReportType.DELIVERIESLOG) {
      <h4 class="modal-title pull-left">{{'DELIVERIES.DELIVERIES_REPORTS' | translate }}</h4>
    }
    @if (selectedReport()?.type === ReportType.FEEDBACK) {
      <h4 class="modal-title pull-left">{{'RAPPORT_TIR.FEEDBACK_REPORT' | translate }}</h4>
    }
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">

    <div class="modal-content">

      <div class="modal-content-item">
        <label for="date">{{'RAPPORT_TIR.SELECT_REPORT'| translate }} </label>
        <ng-select name="selectReport" id="selectReport" [items]="reportTemplates()" bindLabel="name"
          [(ngModel)]="selectedReport" (ngModelChange)="onReportTypeChange($event)" [addTag]="true" [hideSelected]="false" [multiple]="false" [closeOnSelect]="true">
        </ng-select>
        @if (!selectedReport()) {
          <div class="custom-alert custom-alert-sm">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate}}
          </div>
        }
      </div>

      <div class="form-group mb-1">
        <label for="tabProjets">{{'GLOBAL.PROJETS'| translate }} </label>
        <ng-select #projects (change)="onChangeProjects($event)" class="custom" [items]="tabProjets" [multiple]="true"
          placeholder="{{'GLOBAL.PROJETS' | translate}}" [ngModel]="tabProjetsSelected()" [disabled]="false"
          [clearable]="false" name="tabProjets" bindLabel="nom">
        </ng-select>
      </div>

      <div class="row">
        <div class="col-md-8">
          <div class="form-group mb-1">
            <label for="startDate">{{ 'DELIVERY.START_DATE' | translate }}</label>
            <div class="input-group">
              <input placeholder="{{ 'DELIVERY.START_DATE' | translate }}" autocomplete="off" type="text"
                class="form-control" [matDatepicker]="startDatePicker"
                (dateChange)="onDateTimeChange($event.value, 'start_date')" [(ngModel)]="startDate" name="startDate"
                (click)="startDatePicker.open()" (focus)="startDatePicker.open()" readonly />
              
              <mat-datepicker #startDatePicker></mat-datepicker>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-1">
              <label for="startTime">{{ 'DELIVERY.START_TIME' | translate }}</label>
              <app-custom-select
                [options]="startTimeOptions()"
                [placeholder]="'GLOBAL.HOUR' | translate"
                [(ngModel)]="startTime"
                (selectionChange)="onDateTimeChange()"
                name="startTime">
              </app-custom-select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-8">
            <div class="form-group mb-1">
              <label for="endDate">{{ 'DELIVERY.END_DATE' | translate }}</label>
              <div class="input-group">
                <input placeholder="{{ 'DELIVERY.END_DATE' | translate }}" autocomplete="off" type="text"
                  class="form-control" [matDatepicker]="endDatePicker"
                  (dateChange)="onDateTimeChange($event.value, 'end_date')" [(ngModel)]="endDate" name="endDate"
                  (click)="endDatePicker.open()" (focus)="endDatePicker.open()" readonly />
                
                <mat-datepicker #endDatePicker></mat-datepicker>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group mb-1">
                <label for="endTime">{{ 'DELIVERY.END_TIME' | translate }}</label>
                <app-custom-select
                  [options]="endTimeOptions()"
                  [placeholder]="'GLOBAL.HOUR' | translate"
                  [(ngModel)]="endTime"
                  (selectionChange)="onDateTimeChange()"
                  name="endTime">
                </app-custom-select>
              </div>
            </div>
          </div>

          @if (!invalideDate()) {
            <div class="row mt-2">
              <div class="col-md-12">
                @if (duration()) {
                  <div class="alert alert-info">
                    {{'GLOBAL.DURATION' | translate}} : {{ duration() }}
                  </div>
                }
              </div>
            </div>
          }

          @if (invalideDate()) {
            <div class="row mt-2">
              <div class="col-md-12">
                @if (duration()) {
                  <div class="alert alert-danger">
                    {{duration()| translate}}
                  </div>
                }
              </div>
            </div>
          }

          @if (selectedReport()?.type === ReportType.DELIVERIESLOG) {
            <div class="form-group mb-2">
              <label for="deliveriesDates">{{'DELIVERIES.DELIVERIES' | translate}}</label>
              <ng-select #delivery class="custom" [items]="deliveriesDates()" [multiple]="true"
                placeholder="{{'DELIVERIES.DELIVERIES' | translate}}" [(ngModel)]="deliveriesDates" [disabled]="false"
                [clearable]="false" name="deliveriesDates" bindLabel="startTimeFormatted" >
              </ng-select>
            </div>
          }

          @if (selectedReport()?.type === ReportType.FEEDBACK) {
            <div class="form-group mb-2">
              <label for="tirsBySurveyAnswerFiltered">{{'RAPPORT_TIR.FEEDBACK' | translate}}</label>
              <ng-select #feedback class="custom" [items]="tirsBySurveyAnswerFiltered()" [multiple]="true"
                placeholder="{{'GLOBAL.TIR' | translate}}" [(ngModel)]="tirsBySurveyAnswerFiltered" [disabled]="false"
                [clearable]="false" name="tirsBySurveyAnswerFiltered" bindLabel="tirsName" >
              </ng-select>
            </div>
          }


          @if (selectedReport()?.type === ReportType.DELIVERIESLOG) {
            <div class="form-group mb-1 resume">
              <div class="input-group resume-item">
                <input [placeholder]="'OPERATIONS.RESUME' | translate" autocomplete="off" type="checkbox" class="resume-item" name="resume"
                  [(ngModel)]="isResume" />
                  <label for="resume">{{ 'OPERATIONS.RESUME' | translate }}</label>
                </div>
              </div>
            }


          </div>

        </div>
        <div class="modal-footer">
          <div>
            <button class="btn btn-outline-success pull-left" style="margin-right:10px;" type="submit"
            (click)="downloadRepports()">{{'DELIVERIES.DOWNLOAD' | translate}}</button>
          </div>
          <button type="button" class="btn btn-secondary"
          (click)="modalRef.hide()">{{'GLOBAL.FERMER' | translate}}</button>
        </div>


